export const EMPTY_DEFAULT = '-';
export const DEFAULT_COLUMN_MAX_WIDTH = 250;
export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_TABLE_PAGE_SIZE = 100;
